<template>
    <v-card :class="[{'pa-0 grey lighten-4': $vuetify.breakpoint.smAndDown}, 'pb-3']"
            :flat="$vuetify.breakpoint.smAndDown">
        <v-card-title :class="[{'px-4 pt-2 subtitle-1 font-weight-bold': $vuetify.breakpoint.smAndDown},
                                {'pa-5': $vuetify.breakpoint.mdAndUp}]">
            <span :class="[{'mb-2': $vuetify.breakpoint.smAndDown}]">
                Offene <span v-if="!isSpielFremdAdmin">Heimspiele</span><span v-else>Spiele</span>
            </span>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                                        label="in Liste suchen" filled dense class="d-inline-block"
                                        single-line hide-details style="max-width: 350px">
                <template v-slot:append>
                    <v-btn icon small class="pb-1">
                        <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="spiele" :search="search" disable-pagination
                      item-key="name" sort-by="termin" hide-default-footer mobile-breakpoint="1"
                      :class="[{'mx-0': $vuetify.breakpoint.smAndDown},
                               {'mx-4': $vuetify.breakpoint.mdAndUp},
                               'elevation-1 mb-2']">
            <template v-slot:item.liga="{ item }">
                <v-hover v-slot="{ hover }">
                    <span @click="quickSearch(item.liga)" style="cursor: pointer"
                          :class="{ 'primary--text': hover }">{{item.liga}}</span>
                </v-hover>
            </template>
            <template v-slot:item.rundeGroup="{ item }">
                <v-hover v-slot="{ hover }">
                    <span @click="quickSearch(item.rundeGroup)" style="cursor: pointer"
                          :class="{ 'primary--text': hover }">{{item.rundeGroup}}</span>
                </v-hover>
            </template>
            <template v-slot:item.heimTeam="{ item }">
                <v-hover v-slot="{ hover }">
                    <tab-teams-with-icons :item="item" type="heim" @filtered="quickSearch"
                                          :class="{ 'primary--text': hover }">
                    </tab-teams-with-icons>
                </v-hover>
            </template>
            <template v-slot:item.gastTeam="{ item }">
                <v-hover v-slot="{ hover }">
                    <tab-teams-with-icons :item="item" type="gast" @filtered="quickSearch"
                                          :class="{ 'primary--text': hover }">
                    </tab-teams-with-icons>
                </v-hover>
            </template>
            <template v-slot:item.ergebnis="{ item }">
                <div class="text-no-wrap">{{item.ergebnis}}</div>
            </template>
            <template v-slot:item.schnitt="{ item }">
                <div class="text-no-wrap">{{item.schnitt}}</div>
            </template>
            <template v-slot:item.actions="{ item }">
                <div style="white-space: nowrap">
                    <tool-tip text="Mannschaftsaufstellung bearbeiten">
                        <v-btn class="d-inline-block" icon @click="openEdit(item, 'editMaL')">
                            <v-icon>mdi-account-group</v-icon></v-btn>
                    </tool-tip>
                    <tool-tip text="Spielbericht bearbeiten">
                        <v-btn v-if="item.partien['1'].heim.spieler.id" class="d-inline-block" icon
                               @click="openEdit(item, 'editErgebnis')">
                            <v-icon>mdi-table-large</v-icon></v-btn>
                    </tool-tip>
                    <spiel-berichte-print-menu class="d-inline-block" :spielId="item.id"
                                               type="pending"></spiel-berichte-print-menu>
                    <tool-tip text="Große Ansicht für TV">
                        <v-btn v-if="item.partien['1'].heim.spieler.id" icon @click="openTV(item.id)"
                               class="d-inline-block">
                            <v-icon color="blue">mdi-monitor-screenshot</v-icon>
                        </v-btn>
                    </tool-tip>
                    <tool-tip text="Streaming Einstellungen">
                        <v-btn v-if="item.infos.stream" icon @click="openEdit(item, 'streamConsole')"
                               class="d-inline-block" color="blue">
                            <v-icon>mdi-video-wireless-outline</v-icon>
                        </v-btn>
                    </tool-tip>
                    <v-btn v-if="item.infos.stream"
                           @click="openStream(item.infos.stream)" icon class="d-inline-block">
                        <v-icon :color="item.vereine.heim.indexOf('pending') !== -1?'blue':''">
                            mdi-video-box</v-icon>
                    </v-btn>
                </div>
            </template>
            <template v-slot:no-data>
                <td class="text-left font-weight-bold primary--text">
                    Es sind aktuell keine Heimspiele geplant!</td>
            </template>
            <template v-slot:item.status="{ item }">
                <spiel-status-text :spiel="item" @filtered="quickSearch" allow-hover="true"></spiel-status-text>
            </template>
        </v-data-table>
        <div class="caption px-4">
            Klicke auf ein Liga, Runde, Team oder den Status um danach zu filtern, nochmaliges Klicken löscht den Filter.
        </div>
        <div v-if="!isSpielFremdAdmin" class="text-center mt-3" >
            <v-btn v-if="!snapshot.allLoaded" @click="getSpiele(snapshot.limit)"
                   color="primary" small>
                <v-icon small class="mr-2">mdi-download</v-icon>
                mehr laden</v-btn>
            <v-btn v-else @click="refresh()" color="primary" small>
                <v-icon small class="mr-2">mdi-refresh</v-icon>
                aktualisieren</v-btn>
        </div>
        <spiel-bericht-edit-ma-l v-if="$route.query.action==='editMaL'" action="editMaL"
                                 :currentData="spielSelected" @updated="updateList">
        </spiel-bericht-edit-ma-l>
        <spiel-bericht-edit-ergebnis v-if="$route.query.action==='editErgebnis'"
                                     :currentData="spielSelected" action="editErgebnis"
                                     @updated="updateList">
        </spiel-bericht-edit-ergebnis>
        <stream-console v-if="$route.query.action==='streamConsole'" :currentData="spielSelected">
        </stream-console>
    </v-card>
</template>

<script>
    import SpielService from "../../../services/data/spielService";
    import SpielBerichtEditMaL from "./edit/spielBerichtEditMaL";
    import SpielBerichtePrintMenu from "./spielBerichtePrintMenu";
    import SpielBerichtEditErgebnis from "./edit/spielBerichtEditErgebnis";
    import {db} from "../../../services/db";
    import TabTeamsWithIcons from "../components/tabTeamsWithIcons";
    import ToolTip from "../../../components/elements/toolTip";
    import SpielStatusText from "../components/spielStatusText";
    import StreamConsole from "./stream/streamConsole";
    import FirebaseRead from "@/services/database/firebaseRead";

    export default {
        components: {
            StreamConsole,
            SpielStatusText,
            ToolTip,
            TabTeamsWithIcons,
            SpielBerichtEditErgebnis,
            SpielBerichtePrintMenu,
            SpielBerichtEditMaL},
        name: "spiel-berichte-offen-created",
        computed: {
            user(){ return this.$store.state.user; },
            vereinNr(){return this.user.permissions.spielbericht},
            isSpielFremdAdmin(){ return this.$route.path === '/Ergebnisdienst/SpielberichteFremd'},
            path(){ return this.$route.path},
        },
        data: () => ({
            search: '',
            headers: [],
            spiele: [],
            spielSelected: null,
        // paginated load from server
            snapshot: {
                spieleRaw: [],
                lastVisibleSpiel: null,
                nextDataLoad: null,
                allLoaded: false,
                limit: 5,
            }
        }),
        created(){
            this.init()
        },
        methods: {
            init(){
                this.getSpiele(this.snapshot.limit, true);
            },
            quickSearch(content){
                this.search = this.search === content ? '' : content;
            },
            refresh() {
                const limit = this.snapshot.spieleRaw.length > 0 ?
                              this.snapshot.spieleRaw.length : this.snapshot.limit;
                this.snapshot.spieleRaw = [];
                this.snapshot.allLoaded = false;
                this.snapshot.nextDataLoad = null;
                this.getSpiele(limit, false);
            },
            async getSpiele(limit, intialLoad){
                if ( this.isSpielFremdAdmin && this.user.uid ) { this.getSpieleForAdmin(); return }
                if ( this.vereinNr && !this.snapshot.allLoaded ) {
                    this.headers = SpielService.getTableHeader(this.$vuetify,
                        [ {text: 'Status', value: 'status', sortable: true } ]);
                    let first = !this.snapshot.nextDataLoad ? db.collection("spiele")
                        .where('vereine.heim', '==', this.vereinNr + '_pending')
                        .orderBy("infos.datum")
                        .orderBy("infos.uhrzeit")
                        .limit(limit) :
                        this.snapshot.nextDataLoad;
                    return first.get().then(async (documentSnapshots) => {
                        if ( documentSnapshots.docs.length === 0 ) {
                            this.snapshot.allLoaded = true;
                            if ( !intialLoad ) {
                                this.$store.dispatch('clearSnackbar');
                                this.$store.state.globalSnack.text = 'Es wurden alle Datensätze geladen!';
                                this.$store.state.globalSnack.color = 'success';
                                this.$store.state.globalSnack.show = true;
                            }
                            return;
                        }
                    // Get the last visible document
                        const i = documentSnapshots.docs.length-1;
                        this.snapshot.lastVisibleSpiel = documentSnapshots.docs[i];
                    // process data
                        documentSnapshots.forEach( (snapshot) => {
                            let spiel = snapshot.data();
                            spiel.id = snapshot.id;
                            this.snapshot.spieleRaw.push(spiel);
                        });
                        await this.setSpiele();
                    // Construct a new query starting at this document,
                        this.snapshot.nextDataLoad = db.collection("spiele")
                            .where('vereine.heim', '==', this.vereinNr + '_pending')
                            .orderBy("infos.datum")
                            .orderBy("infos.uhrzeit")
                            .startAfter(this.snapshot.lastVisibleSpiel)
                            .limit(this.snapshot.limit);
                    });
                }
            },
            async getSpieleForAdmin(){
                this.headers = SpielService.getTableHeader(this.$vuetify,
                    [ {text: 'Status', value: 'status', sortable: true } ]);
                let spiele = await FirebaseRead.readDocList('spiele', {
                    field: 'admin', operator: '==', value: this.user.uid
                })
                spiele = spiele.filter(spiel => spiel.vereine.heim.indexOf('_pending') !== -1)
                this.spiele = await SpielService.setSpieleList(JSON.parse(JSON.stringify(spiele)))
            },
            async setSpiele(){
                if ( this.snapshot.spieleRaw.length > 0  ) {
                    this.spiele = await SpielService.setSpieleList(this.snapshot.spieleRaw)
                }
            },
        // edit content
            async openEdit(spiel, action){
                this.$store.state.local.loader = true;
                db.collection("spiele").doc(spiel.id).get().then((doc) => {
                    if (doc.exists) {
                        spiel = doc.data();
                        spiel.id = doc.id;
                        this.spielSelected = spiel;
                        let p = JSON.parse(JSON.stringify(this.$route.path));
                        let q = JSON.parse(JSON.stringify(this.$route.query));
                        q.action = action;
                        this.$router.push({path: p, query: q});
                        this.$store.state.local.loader = false;
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                        this.$store.state.local.loader = false;
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                    this.$store.state.local.loader = false;
                });
            },
        // refresh list after update
            async updateList( updatedSpiel ){
                for ( let i = 0; i < this.spiele.length; i++ ) {
                    if ( this.spiele[i].id === updatedSpiel.id ) {
                        if ( updatedSpiel.vereine.heim !==
                             updatedSpiel.heim.vereinsNr + '_pending') {
                            this.spiele.splice(i, 1 );
                        } else {
                            this.spiele.splice(i, 1, await SpielService.setSpiel(updatedSpiel) );
                        }
                        return;
                    }
                }
            },
        // TV preview
            openTV(spielId){
                let routeData = this.$router.resolve({name: 'ShowTv', query: {id: spielId}});
                window.open(routeData.href, '_blank');
            },
        // Stream
            openStreamConsole(spielId){
                let routeData = this.$router.resolve({name: 'StreamConsole', query: {id: spielId}});
                window.open(routeData.href, '_blank');
            },
        // open live stream
            openStream(url){
                window.open(url, '_blank').focus();
            }
        },
        watch: {
            vereinNr(){
                this.getSpiele(this.snapshot.limit, true);
            },
            'user.uid'(to, from){
                if ( to && !from ) this.getSpiele(this.snapshot.limit, true);
            },
            path(){
                this.init()
            }
        }
    }
</script>

<style scoped>

</style>